module.exports = __webpack_public_path__ + "img/fantan-image-box.412208df.jpg";